<template>
  <div class="booleanfield">
    {{ formattedValue }}
  </div>
</template>

<script>
export default {
  name: 'tablefield-boolean',
  props: ['data', 'config'],
  computed: {
    formattedValue() {
      let nullyValue = this._.get(this, 'config.decoratorOptions.nully')
      if (nullyValue && ((this.data === null) || (this.data === undefined))) {
        return nullyValue
      }

      if (this._.isNil(this.data) || this.data === '') {
        return '—'
      } else {
        return this.data
          ? this._.get(this, 'config.decoratorOptions.truthy', 'ja')
          : this._.get(this, 'config.decoratorOptions.falsy', 'nein')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldBoolean.vue?79fc9a69